import { render } from "./PasswordPage.vue?vue&type=template&id=7d72a34a&scoped=true"
import script from "./PasswordPage.vue?vue&type=script&lang=js"
export * from "./PasswordPage.vue?vue&type=script&lang=js"

import "./PasswordPage.vue?vue&type=style&index=0&id=7d72a34a&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../../../../Users/jamarrucho/Documents/2024/04_Unit/Dev/unit-org_2025_10_24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d72a34a"]])

export default __exports__